import { render } from "./InformationIcon.vue?vue&type=template&id=12247576"
import script from "./InformationIcon.vue?vue&type=script&lang=js"
export * from "./InformationIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/shared/Icons/InformationIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12247576"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12247576', __exports__)) {
    api.reload('12247576', __exports__)
  }
  
  module.hot.accept("./InformationIcon.vue?vue&type=template&id=12247576", () => {
    api.rerender('12247576', render)
  })

}


export default __exports__